import { curry } from 'lib/util'
import asObject from 'lib/sequence/component/children/asObject'

/**
 * Child Or ACL Event Handler
 *
 * Tries to apply the child's `aclHandler` handler if set in its
 * config. If not, it'll apply the fallback handler. The fallback
 * handler must be defined in the module's `events.js`.
 *
 * @param {Gaia.Component.EventHandler} fallback  the fallback acl handler
 * @param {Gaia.AppModule.Spec} module            the current module composition object
 * @param {Gaia.Component.Spec} component         the current action's main component
 * @param {string} key                            the component's `key`
 */
const childOr = (fallback, module, component, { key }) => {
  const { [key]: child } = asObject(component[G.CHILDREN])
  const childHandler = module[G.EVENTS].acl?.[child[G.CONFIGURATION].aclHandler]

  return (childHandler || fallback)(module, component, { key })
}

export default curry(childOr)
